import { Fragment as _Fragment, jsx as _jsx } from "@emotion/react/jsx-runtime";
export default function Checkout(props) {
    return (_jsx(_Fragment, { children: "Checkout" }));
}
